<template>
   <div>
      <div class="pagecontainer container">
         <div  class="groupone">
            <div>
               <span class="widthbanner">Upload Video Profile</span>
               <button>Save</button>
               <button>Draft</button>
            </div>
         </div>
         <div class="columnleft">
            <button @click="none" :hidden="videonull">Normal</button>
            <button @click="grayscale" :hidden="videonull">grayscale</button>
            <button @click="brightness" :hidden="videonull">brightness</button>
            <button @click="contrast" :hidden="videonull">contrast</button>
            <button @click="invert" :hidden="videonull">Invert</button>
            <br><br>
            <center>
               <p>
                    
                  
                 
                     <div v-if="video !=''">       
                           <video id="video"  autoplay controls  width=320 >     
                  <source :src="video" ></source>
                     </video>     </div>
              <video v-else id="video" autoplay  width=320 >   
                     </video> 
               </p>
                
            </center>
            <center>
               <p>Your videos will be private until you publish them</p>
            </center>
            <div class="fileUpload btn btn-primary">
               <center>  
                  <input type="file"class="upload" accept="video/mp4,video/x-m4v,video/*" name="image"  id="file" @change="loadFile()">     
                  <button>Upload</button>
               </center>
            </div>
            <p><button @click="startFunction()">Grab video & start recording</button></p>
            <p><button @click="download()">Download! (and stop video)</button></p>
         </div>
         <div class="column">
            <div v-if="video !='' ">
               <div class="heading"><span><b> Details</b></span></div>
               <h4>Add Details</h4>
               <p>Thumbnail</p>
             <video id="video" :src="video"  width=320 />
             
               <p>Details</p>
               <div class="form-group">
                  <div class="floating-label col-50">
                     <input  class="floating-input "  id="floating-input"  type="text"  placeholder=" ">
                     <span class="highlight"></span>
                     <label>Title</label>
                  </div>
               </div>
               <div class="form-group">
                  <textarea cols="10" rows="10" placeholder="Description" maxlength="1040"></textarea>
               </div>
            </div>
         </div>
      </div>
      <BottomFooter></BottomFooter>
   </div>
</template>
<script>
   import BottomFooter from '@/components/BottomFooter.vue'
   export default{
        components: {
                
                  BottomFooter,
              },
   data(){
       return{
     video: "",
     testing:'',
     videonull:true,
     theStream:'',
    theRecorder:'',    
    recordedChunks : [],
       }
   },
   methods:{
         none(){
   document.getElementById("colorchange").style.filter = "none";
       },
      grayscale(){
   document.getElementById("colorchange").style.filter = "grayscale(100%)";
       },
       brightness(){
   document.getElementById("colorchange").style.filter = " brightness(200%)";
       },
        contrast(){
   document.getElementById("colorchange").style.filter = " contrast(200%)";
       },
       invert(){
   document.getElementById("colorchange").style.filter = "invert(100%)";
       },
   
   
   
       
    startFunction() {
      this.video=''      
   const constraints = { "video": { width: { max: 320 } }, "audio" : true };
     navigator.mediaDevices.getUserMedia(constraints).then(this.gotMedia)    
         .catch(e => { console.error('getUserMedia() failed: ' + e); });
   },
   
    gotMedia(stream) {
         this.video=''
     this.theStream = stream;
     var video = document.querySelector('video');
     video.srcObject = stream;
     try {
       var recorder = new MediaRecorder(stream, {mimeType : "video/webm"});
     } catch (e) {
       console.error('Exception while creating MediaRecorder: ' + e);
       return;
     }
     
     this.theRecorder = recorder;
     recorder.ondataavailable = 
         (event) => { this.recordedChunks.push(event.data); };
     recorder.start(100);
    
   },
   
    download() {      
     this.video=''
     this.theRecorder.stop();        
     this.theStream.getTracks().forEach(track => { track.stop(); });
     var blob = new Blob(this.recordedChunks, {type: "video/webm"});
     var url =  URL.createObjectURL(blob);      
     this.video=url
    /* var a = document.createElement("a");
     document.body.appendChild(a);   
     a.href = url;
     a.download = 'test.webm'; 
     a.click();*/
    
    
     setTimeout(function() { URL.revokeObjectURL(blob); }, 100); 
    
    },
                    loadFile:function() {     
                        
                            this.videonull=false;             
         	var image = document.getElementById('file').value;
         
     this.video = URL.createObjectURL(event.target.files[0]);
     console.log( this.video)
                        
      }, 
   }}
</script>
<style scoped>
   label {
   color:black; 
   font-size:12px;
   font-weight:normal;
   position:absolute;
   pointer-events:none;
   left:0px;
   top:5px;
   transition:0.2s ease all; 
   -moz-transition:0.2s ease all; 
   -webkit-transition:0.2s ease all;
   }
</style>